import {
  Button,
  Link,
  makeStyles,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utilities/Axios";
import AuthContext from "../../Hooks/AuthContext/AuthContext";
import React from "react";
import MuiAlert, { Alert, AlertProps, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme: any) => ({
  formItemStyle: {
    width: "75%",
    marginLeft: "12.5%",
  },
  loginButton: {
    width: "50%",
    marginBottom: "1%",
    paddingTop: "2%",
    paddingBottom: "2%",
  },
}));

const LoginForm = (props: {
  cardName: string;
  isSignUp: boolean;
  cardStyle: string;
}) => {
  const { login, init } = useContext(AuthContext);
  const [open, setOpen] = useState<any>(false);
  const [message, setMessage] = useState("");
  const [user, setUser] = useState<any>({
    username: "",
    email: "",
    password: "",
  });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const classes = useStyles();
  const formRef = useRef<any>();
  const navigate = useNavigate();

  const cardStyle = "bg-white w-full md:w-1/3 rounded-3xl  " + props.cardStyle;

  const [severity, setSeverity] = useState<MuiAlert.AlertColor>();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const loginUser = async (data: any) => {

    if (props.isSignUp) {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/account/login`;

        const res = await axiosInstance.post(url, data);

        login(res.data.result);

        window.location.href = "/login";
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        const url = `${process.env.REACT_APP_API_ORIGIN}/v1/account/login`;

        const res = await axiosInstance.post(url, data);

        login(res.data.result);
        init();
        enqueueSnackbar("Login Successful!!!", { variant: "success" });
        navigate({
          pathname: "/admin",
        });
      } catch (err: any) {
        let errMsg = "Unknown";
        if (err?.response?.data?.error) {
          errMsg = err.response.data.error;
        }
        enqueueSnackbar(`Invalid Login Details!!! ${err.response.data.error}`, {
          variant: "error",
        });
        console.error(err);
      }
    }
  };

  return (
    <>
      <div
        className="flex flex-col md:place-items-center bg-slate-100 py-6"
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <div className={cardStyle}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: 10,
            }}
          >
            <img
              src="/img/full_logo.png"
              alt="Logo"
              style={{
                width: "200px",
              }}
            ></img>
          </div>
          <div className="text-center mb-6 font-semibold text-2xl">
            {props.cardName}
          </div>
          <Formik
            initialValues={user}
            validationSchema={Yup.object().shape({
              username: Yup.string().required("Username is Required"),
              password: Yup.string().required("Password is Required"),
            })}
            onSubmit={loginUser}
            innerRef={formRef}
          >
            {({
              handleChange,
              handleBlur,
              handleSubmit,
              values,
              touched,
              errors,
            }) => (
              <form>
                <div className="flex flex-col space-y-4">
                  <div className="flex flex-col space-y-2">
                    {/* <div className="mx-10 md:mx-14">
                      <label>Username</label>
                    </div> */}

                    <TextField
                      label="Username"
                      className={classes.formItemStyle}
                      id="username"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.username}
                      placeholder="Enter your username"
                      size="small"
                      name="username"
                      error={Boolean(touched.username && errors.username)}
                      helperText={
                        errors.username &&
                        touched.username &&
                        String(errors.username)
                      }
                    />
                  </div>
                  {props.isSignUp && (
                    <div className="flex flex-col space-y-2">
                      {/* <div className="mx-10 md:mx-14">
                        <label>Email</label>
                      </div> */}

                      <TextField
                        className={classes.formItemStyle}
                        label="Email"
                        id="email"
                        variant="outlined"
                        onChange={handleChange}
                        value={values.email}
                        placeholder="Enter your email"
                        size="small"
                        name="email"
                        error={Boolean(touched.email && errors.email)}
                      />
                    </div>
                  )}
                  <div className="flex flex-col space-y-2">
                    {/* <div className="mx-10 md:mx-14">
                      <label>Password</label>
                    </div> */}

                    <TextField
                      className={classes.formItemStyle}
                      label="Password"
                      id="password"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.password}
                      placeholder="Enter your password"
                      size="small"
                      name="password"
                      type="password"
                      error={Boolean(touched.password && errors.password)}
                      helperText={
                        errors.password &&
                        touched.password &&
                        String(errors.password)
                      }
                    />
                  </div>
                  {props.isSignUp && (
                    <div className="flex flex-col space-y-2">
                      <div className="mx-10 md:mx-14">
                        <label>Confirm Password</label>
                      </div>

                      <TextField
                        className={classes.formItemStyle}
                        id="confirmpassword"
                        variant="outlined"
                        onChange={handleChange}
                        value={values.confirmpassword}
                        placeholder="Confirm your password"
                        size="small"
                        name="confirmpassword"
                        type="password"
                        error={Boolean(
                          touched.confirmpassword && errors.confirmpassword
                        )}
                      />
                    </div>
                  )}
                  <div className="flex pt-3 justify-center">
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.loginButton}
                      onClick={() => {
                        handleClick();
                        handleSubmit();
                      }}
                    >
                      {props.cardName}
                    </Button>
                  </div>
                  {!props.isSignUp && (
                    <>
                      {/* <Link className="text-center cursor-pointer">
                        Forgot Password
                      </Link> */}

                      <div className="flex flex-row mx-10 md:mx-14 justify-center space-x-1">
                        <div>Having trouble log in?</div>
                        <Link
                          className="cursor-pointer font-bold"
                          href="/#"
                          // onClick={(event: any) =>
                          //   (window.location.href = "/signUp")
                          // }
                        >
                          Contact Support
                        </Link>
                      </div>
                    </>
                  )}

                  {props.isSignUp && (
                    <div className="flex flex-row mx-10 md:mx-14 justify-center space-x-1">
                      <div>Already Registered?</div>
                      <Link
                        className="cursor-pointer font-bold"
                        onClick={(event: any) =>
                          (window.location.href = "/login")
                        }
                      >
                        Sign In
                      </Link>
                    </div>
                  )}

                  <div>
                    <div></div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
        <div></div>
      </div>
    </>
  );
};

export default LoginForm;
